import Vue from 'vue'
import App from './App'
import router from './router'
import './assets/css/base.less'
import 'lib-flexible/flexible'
import Util from './utils/util'
import Vant from 'vant'
import 'vant/lib/index.css'
import store from './vuex/store'
import Vuex from 'vuex'
//axios
import {apiAxios} from './utils/http.js'

Vue.use(Util)

Vue.use(Vant);

Vue.use(Vuex)

Vue.prototype.$http = apiAxios;

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')




// WEBPACK FOOTER //
// ./src/main.js